<template>
  <form ref="form">
    <div class="question-text" v-html="getQuestionText"></div>
    <div v-for="(choice, index) in data.choices" :key="index" :class="{ 'spaced': choice.spaced }">
      <div class="input-group" :class="isChecked(choice.id)">
        <label :for="`input_checkbox_`+choice.id" @click="selected(choice)">
          <input
            type="number"
            :name="data.id"
            :id="choice.id"
            :ref="`input_${choice.id}`"
            @click="selected(choice)"
            class="input-tom"
            disabled
          >
          <span v-html="getChoiceText(choice.id)"></span>

          <span v-if="choice.custom">
            <input
              type="text"
              :id="`custom_${choice.id}`"
              :ref="`custom_${choice.id}`"
              @keyup="setCustomValue(choice)"
              @click="selected(choice)"
            >
          </span>
        </label>
      </div>
    </div>

    <button type="button" class="previous" @click="prev">Previous</button>
    <button
      @click.prevent="next"
      :disabled="nextBtnDisabled"
      :class="{ active: !nextBtnDisabled }"
      class="next"
    >Next</button>

    <!--<p>{{ answer }}</p>-->
  </form>
</template>

<script>
export default {
    name: 'top-of-mind',

    props: {
      data: {
        required: true,
        type: Object
      }
    },

    created() {
      this.options = new Array;
      for(let i in this.data.choices){
        i++;
        this.options.push(i);
      }
      this.total = this.data.choices.length
    },

    data() {
        return {
            nextBtnDisabled: true,
            answer: {
              question: this.data.id,
              choices: []
            },
            options: [],
            total: 0,
            customValue: ''
        }
    },

    methods: {
        selected(choice){
          // to disable after selecting the choice
          // this.$refs['input_'+choice.id][0].disabled = true;
          let el = this.$refs[`input_${choice.id}`][0];
          const choiceValue = el.value;

          if ( el.value == '' ){
            this.$refs['input_'+choice.id][0].value = this.options.shift();
            this.answer.choices.push({
              "id": choice.id,
              "custom": el.value
            });
          } else {
            document.querySelectorAll('.input-tom').forEach(input => {
              if (parseInt(input.value) >= parseInt(choiceValue)){
                // remove the answer
                let index = this.answer.choices.findIndex(c => c.id == input.id);
                if (index !== -1){
                  this.answer.choices.splice(index, 1)
                  // repopulate the options
                  this.options.push(parseInt(input.value))
                  this.options.sort()
                  input.value = ''
                }
              }
            })
          }


            if ( choice.custom && choice.custom.mandatory ) {
              if ( this.$refs[`custom_${choice.id}`][0].value === '' ) {
                return this.$refs[`custom_${choice.id}`][0].focus();
              }
            }
        },

        setCustomValue(choice) {
            console.log('setCustomValue %s', choice.id)
            console.log(this.$refs[`custom_${choice.id}`][0].value )
            if ( this.$refs[`custom_${choice.id}`][0].value !== '' ) {
              this.customValue = this.$refs[`custom_${choice.id}`][0]['value'].trim();
              this.selected(choice)
            }
        },

        next(){
            this.$emit('next-question', this.answer)
        },

        prev() {
          this.$emit('prev-question')
        },

        isChecked(choiceId) {
          return this.answer.choices.find(c => c.id === choiceId) ? 'active' : ''
        },

        getChoiceText(choiceId) {
          const index = this.data.choices.findIndex(c => c.id == choiceId);
          const textIndex = this.data.choices[index].text.findIndex(t => t.lang == this.$parent.lang);
          return this.data.choices[index].spaced ? this.data.choices[index].text[textIndex].html.substr(1) : this.data.choices[index].text[textIndex].html;
        }
    },

    computed: {
      getQuestionText() {
        const index = this.data.text.findIndex(t => t.lang == this.$parent.lang)
        return this.data.text[index].html;
      }
    },

    watch: {
      'answer.choices': function(val) {
        if( val.length < this.data.choices.length ){
          this.nextBtnDisabled = true
        } else {
          this.nextBtnDisabled = false
        }
      }
    }
}
</script>